<template>
    <div class="tabs_content">
      <section>
        <div class="status">
          <h2 v-translate>Kodeky</h2>
          <a v-if="availableCodecs.length > 0 && isEditable" class="add add_expand"
             :class="{ open: this.addCodecOpened }" @click.stop="toggleAddCodec" :title="'Přidat kodek' | translate"
             v-translate>Přidat kodek</a>
        </div>

        <div class="filter expand_content" :class="{ open: addCodecOpened }">
          <div class="field_left">
            <select-box id="codec" v-model="selectedCodec" :options="codecOptions">
              <translate class="translate">Kodek</translate>
            </select-box>
          </div>

          <div class="field_right">
            <p class="field">
              <input class="btn" type="button" :value="'Přidat' | translate" @click.stop="addCodec"/>
            </p>
          </div>
        </div>

        <div class="scroll-wrapper">
          <div class="table_overflow" id="contentBox" data-table-id="device-profiles-codecs">
            <table class="vypis vypis_detail">
              <tbody :class="{sortable: isEditable}">
              <tr v-for="idCodec in this.entity.codec_order" :rowid="idCodec" class="sorted_codecs"
                  :key="'codec_' + idCodec">
                <td class="no_padding drag_drop"><span/></td>
                <td class="first_data no_padding_left">{{ getCodecName(idCodec) }}</td>

                <td class="no_padding edit">
                  <div class="edit_inner" v-if="isEditable">
                    <a class="btn btn_action btn_delete" @click.stop="removeCodec(idCodec)"
                       :title="'Smazat' | translate" v-translate>Smazat</a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
</template>

<script>

export default {
    name: "Codecs",
    props: {
        entity: Object,
        codecs: Array,
        isEditable: Boolean
    },
    data() {
        return {
            addCodecOpened: false,
            selectedCodec: null,
        }
    },
    mounted() {
        if (this.isEditable) {
            $(".sortable").sortable({
                stop: this._updateSortedCodecs
            });
        }
    },
    methods: {
        getCodecName(idCodec) {
            let codec = this.codecs.find((codec) => codec.id == idCodec);
            return codec ? codec.name : null;
        },
        removeCodec(idCodecToRemove) {
            this.entity['codec_order'] = this.entity['codec_order'].filter((idCodec) => idCodec != idCodecToRemove);
        },
        toggleAddCodec() {
            this.addCodecOpened = !this.addCodecOpened;
            if (this.addCodecOpened) {
                this.selectedCodec = ~~this.availableCodecs[0].id;
            }
        },
        addCodec() {
            this.entity['codec_order'] = [...this.entity['codec_order'], ~~this.selectedCodec];
        },
        _updateSortedCodecs() {
            const newCodecSort = [];

            $(".sorted_codecs").each((el, x) => {
                newCodecSort.push(~~$(x).attr('rowid'));
            });

            this.entity.codec_order = newCodecSort;
        }
    },
    computed: {
        availableCodecs() {
            let availableCodecs = this.codecs.filter((codec) => !this.entity.codec_order.includes(codec.id));

            if (availableCodecs.length > 0) {
                this.selectedCodec = ~~availableCodecs[0].id;
            } else {
                this.addCodecOpened = false;
            }

            return availableCodecs;
        },
        codecOptions() {
            return this._.map(this.availableCodecs, function (item) {
                return {id: item['id'], text: item['name']}
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/forms/Codecs.vue